import React from 'react';
import styled from 'styled-components';
import { media } from 'utils/style';
import { useTranslation } from 'react-i18next';
import XPOLandingBg from 'assets/backgrounds/xpo-landing-bg.png';
import XPOTimeIcon from 'assets/icons/xpo/time-clock.svg';
import XPOArrowLeft from 'assets/icons/xpo/arrow-left.svg';

const LandingCover = styled.div`
  display: flex;
  width: 50%;
  height: 100%;
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.20),
      rgba(0, 0, 0, 0.70)
    ),
    url(${XPOLandingBg});
  background-size: cover;
  background-position: center;
  ${media.lessThan('small')`
    width: 100%;
  `};
`;

const LandingCoverContainer = styled.div`
  display: inline-block;
  align-self: flex-end;
  padding: 0px 50px 100px 50px;
  ${media.lessThan('extraSmall')`
    padding: 0px 24px 70px 24px;
  `};
`;

const LandingLabelTitle = styled.label`
  display: block;
  color: var(--white);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 32px;
  font-weight: 500;
  cursor: text;
  width: 75%;
  padding-bottom:20px;
  ${media.lessThan('extraSmall')`
    font-size: 24px;
  `};
`;

const LandingLabelText = styled.label`
  display: block;
  color: var(--white);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  cursor: text;
  width: 90%;
  padding-bottom:20px;
  ${media.lessThan('extraSmall')`
    font-size: 16px;
  `};
`;

const LandingLabelTime = styled.label`
  display: flex;
  align-items: center;
  color: var(--white);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 32px;
  font-weight: 500;
  cursor: text;
  ${media.lessThan('small')`
    font-size: 20px;
  `};

  &::before {
    content: '';
    display: inline-block;
    width: 32px;
    height: 32px;
    margin-right: 16px;
    background-image: url(${XPOTimeIcon});
    background-size: contain;
    background-repeat: no-repeat;
    ${media.lessThan('small')`
      width: 16px;
      height: 16px;
      margin-right: 8px;
  `};
  }
`;

const LandingLabelAccess = styled.label`
  display: none;
  color: var(--white);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 32px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  text-align:center;
  padding-top:50px;
  ${media.lessThan('small')`
    display: block;
    font-size: 24px;
  `};

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 24px;
    margin-bottom: 12px;
    background-image: url(${XPOArrowLeft});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const Cover = () => {
    const { t } = useTranslation('Landing');
  
    return (
      <LandingCover id="landing-cover">
          <LandingCoverContainer>
          <LandingLabelTitle>{t('cover.title')}</LandingLabelTitle>
          <LandingLabelText>{t('cover.subtitle')}</LandingLabelText>
          <LandingLabelTime>{t('cover.time')}</LandingLabelTime>
          <LandingLabelAccess onClick={() => {
                    document.querySelector('#landing-content').scrollIntoView({
                      behavior: 'smooth'
                    });
                  }}>
            {t('cover.access')}   
          </LandingLabelAccess>
          </LandingCoverContainer>
        </LandingCover>
    );
  };